export const SET_MESSAGE_CENTRE_URL = "SET_MESSAGE_CENTRE_URL";
export const RESET_MESSAGE_CENTRE_URL = "RESET_MESSAGE_CENTRE_URL";

const initialState = {
  messageCentreUrl: null
};

export default (state = initialState, { type, payload }) => {
  if (type === SET_MESSAGE_CENTRE_URL) {
    return {
      ...state,
      messageCentreUrl: payload
    };
  } else if (type === RESET_MESSAGE_CENTRE_URL) {
    return {
      ...state,
      messageCentreUrl: null
    };
  }
  return state;
};
